<template>
  <div class="drag-able" ref="dragAbleRef">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
import { addEvent, prEvent, removeEvent } from '@/utils'
import { nextTick, onMounted, ref } from 'vue';

const dragAbleRef = ref()
const onDrag = () => {
  const drag = dragAbleRef.value

  addEvent(drag, 'mousedown', function (ev) {
    var oEvent = prEvent(ev)
    var oParent = drag.parentNode

    var disX = oEvent.clientX - drag.offsetLeft
    var disY = oEvent.clientY - drag.offsetTop
    var startMove = function (ev) {
      if (oParent.setCapture) {
        oParent.setCapture()
      }
      var oEvent = ev || window.event
      var L = oEvent.clientX - disX
      var T = oEvent.clientY - disY

      drag.style.left = L + 'px'
      drag.style.top = T + 'px'

      oParent.onselectstart = function () {
        return false
      }
    }
    var endMove = function () {
      if (oParent.releaseCapture) {
        oParent.releaseCapture()
      }
      oParent.onselectstart = null

      removeEvent(oParent, 'mousemove', startMove)
      removeEvent(oParent, 'mouseup', endMove)
      removeEvent(window, 'mouseup', endMove)
    }
    addEvent(oParent, 'mousemove', startMove)
    addEvent(oParent, 'mouseup', endMove)
    addEvent(window, 'mouseup', endMove)
    return false
  })
}

// eslint-disable-next-line no-undef
const emits = defineEmits(['resize'])
const onWheel = () => {
  const drag = dragAbleRef.value

  drag.addEventListener('wheel', (event) => {
    event.preventDefault();

    const dwidth = document.body.clientWidth
    const dheight = document.body.clientHeight
    const ratioL = (event.clientX - (dwidth - 700) / 2 - drag.offsetLeft) / drag.offsetWidth
    const ratioT = (event.clientY - (dheight - 700) / 2 - drag.offsetTop) / drag.offsetHeight

    const ratioDelta = event.deltaY < 0 ? 1.1 : 0.9
    const w = drag.offsetWidth * ratioDelta
    const h = drag.offsetHeight * ratioDelta
    const l = Math.round(event.clientX - (dwidth - 700) / 2 - w * ratioL)
    const t = Math.round(event.clientY - (dheight - 700) / 2 - h * ratioT)

    drag.style.width = w + 'px'
    drag.style.height = h + 'px'
    drag.style.left = l + 'px'
    drag.style.top = t + 'px'

    emits('resize', { w, h, l, t })
  })
}

onMounted(() => {
  nextTick(() => {
    onDrag()
    onWheel()
  })
})
</script>

<style lang="less" scoped>
.drag-able {
  position: absolute;
  cursor: move;
}
</style>